<template>
    <v-row justify="end" >
        <v-btn
            @click.stop="editDialog = true"
            color="#318ef4"
            dark
        >
            Añadir bot
        </v-btn>
        <v-dialog width="450px" v-model="editDialog">
            <v-card>
                <v-container>
                    <v-row  >
                        <v-col cols="12">
                            <v-card-title>
                                <v-col class="text-center" >
                                    <h3 :style="`color:${mainColor}`">Agregar Nuevo Bot</h3>
                                </v-col>
                            </v-card-title>
                        </v-col>
                    </v-row>
                    <v-row  >
                        <v-col cols="12">
                            <v-card-text>
                                <v-text-field
                                    name="companyName"
                                    label="Nombre de la empresa"
                                    v-model="companyName"
                                    :rules="[rules.required]"
                                ></v-text-field>
                                <v-textarea
                                    v-model="description"
                                    name="description"
                                    label="Descripción"
                                    multi-line
                                    :rules="[rules.required]"
                                ></v-textarea>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-row  >
                        <v-col cols="12">
                            <v-card-actions>
                                <v-col class="text-center" >
                                    <v-btn color="#318ef4" text @click="editDialog = false">Cerrar</v-btn>
                                    <v-btn color="#318ef4" dark @click="onSaveBot">Guardar</v-btn>
                                </v-col>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import * as constants from '../../../../constants.json'

export default {
  props: ['companies'],
  data () {
    return {
      editDialog: false,
      companyName: '',
      description: '',
      creationDate: new Date(),
      mainColor: constants.MAINCOLOR,
      rules: {
        required: value => !!value || 'Campo requerido'
      }
    }
  },
  methods: {
    onSaveBot () {
      if (this.companyName.trim() === '' || this.description.trim() === '') {
        return
      }
      this.editDialog = false
      // eslint-disable-next-line
            console.log('companies: ', this.companies)
      this.$store.dispatch('actionAddCompany', {
        companyName: this.companyName.toUpperCase(),
        description: this.description,
        creationDate: this.creationDate })
    }
  }
}
</script>
